import { whale } from '../../../components/shared/vector-images';
import { toggleLayerIfRequired } from '../_helpers';

const layer = {
  displayName: 'Environmental zones',
  synonyms: '',
  group: 'mapboxLayer',
  typeUrl: 'environment',
  icon: {
    baseShape: whale,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 100,
  menuOptions: {
    visible: true,
    owningMenu: 'safety',
    order: 1000,
  },
};

layer.onInitialize = (/* map */) => {
  /* noop */
};

layer.onToggle = (map, show) => {
  toggleLayerIfRequired(map, 'environment line', show);
  toggleLayerIfRequired(map, 'environment fill', show);
  toggleLayerIfRequired(map, 'environment symbol', show);
};

export default layer;
